import classNames from 'classnames';
import isString from 'lodash-es/isString';
import { ElementType, isValidElement, ReactNode } from 'react';
import { Link } from 'wouter';

import SurtitleTypography from '../typography/Surtitle';

import styles from '../../styles/partials/surtitle.module.css';

export type SurtitleValue =
    | ReactNode
    | {
          label?: ReactNode;
          url?: string;
      }
    | null;

export interface SurtitleProps {
    surtitle?: SurtitleValue;
    tag?: ElementType;
    clickRef?: string | null;
    withLink?: boolean;
    placeholder?: boolean;
    className?: string | null;
}

const Surtitle = ({
    surtitle = null,
    tag = null,
    clickRef = null,
    withLink = false,
    placeholder = false,
    className = null,
}: SurtitleProps) => {
    const { label = null, url = null } =
        isString(surtitle) || isValidElement(surtitle)
            ? { label: surtitle }
            : (surtitle as { label?: ReactNode; url?: string }) || {};
    if (label === null) {
        return null;
    }
    const hasLink = withLink && url !== null;
    return (
        <SurtitleTypography
            className={classNames([styles.container, className || undefined])}
            tag={tag || 'h4'}
            placeholder={placeholder}
        >
            {hasLink ? (
                <Link href={url} data-click-ref={clickRef} className={styles.link}>
                    {label}
                </Link>
            ) : (
                label
            )}
        </SurtitleTypography>
    );
};

export default Surtitle;
